<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <transport-form
    *ngIf="transport.isLoaded"
    [transport]="transport"
    [freighter]="freighter"
    (saved)="onUpdated()"
    (back)="onBackToList()"
  ></transport-form>
</div>
